import axios from "axios";
import { storeAuthTokens } from "./authSession";

const API_URL = "https://lukkypro.ru/api/v1/";

export const login = async (username: string, password: string) => {
    const { data } = await axios.post(
        `${API_URL}auth/token`,
        new URLSearchParams({ username, password }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );
    storeAuthTokens(data);
    return data;
};

export const register = async (first_name: string, email: string, password: string, password_verification: string) => {
    const { data } = await axios.post(
        `${API_URL}auth/register`,
        JSON.stringify({ first_name, email, password, password_verification }),
        { headers: { "Content-Type": "application/json" } }
    );
    return data;
};
